import { CommonModule } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { UntilDestroy } from '@ngneat/until-destroy';
import { BaseCellRendererComponent } from '@y42/ag-grid';
import { connectState } from '@y42/angular/util';
import { StopPropagationModule } from '@y42/core/stop-propagation';
import { assertNonNullable } from '@y42/util/assert';
import { ICellRendererParams } from 'ag-grid-community';
import { map } from 'rxjs';
import { OrchestrationRunJobEntity } from '../orchestration-run-jobs-list-ag-grid-config.service';

export interface AssetPathCellRendererParams {
  allowAssetRedirection?: boolean;
  redirectToAsset: (path: string) => void;
}

type IAssetPathCellRenderer = ICellRendererParams & AssetPathCellRendererParams;

@UntilDestroy()
@Component({
  selector: 'y42-asset-path-cell-renderer',
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [CommonModule, MatButtonModule, StopPropagationModule],
  templateUrl: './asset-path-cell-renderer.component.html',
  styleUrls: ['./asset-path-cell-renderer.component.scss'],
})
export class AssetPathCellRendererComponent extends BaseCellRendererComponent<
  string,
  OrchestrationRunJobEntity,
  IAssetPathCellRenderer
> {
  readonly state = connectState(this, {
    path: this.valueAsSingle$,
    allowAssetRedirection: this.params$.pipe(map((params) => !!params.allowAssetRedirection)),
  });

  redirect(path: string | undefined) {
    if (!path) {
      return;
    }
    assertNonNullable(this.params);
    this.params.redirectToAsset(path);
  }
}
